import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ManufacturerInfoModel } from 'app/models/manufacturer-info/manufacturer-info.model';
import { FormService } from 'app/services/form.service';
import { StatesDisplayAndAPI, stateDisplayNameAndApiName } from 'app/utilities/states';

@Component({
  selector: 'app-manufacturers',
  templateUrl: './manufacturers.component.html',
  styleUrls: ['./manufacturers.component.scss']
})

export class ManufacturersComponent implements OnInit {
  @Input() includesAddress = false;
  @ViewChild('manufacturersInput') manufacturersInput!: ElementRef;
  @ViewChild('nameInput') applicantInput!: ElementRef;
  @ViewChild('street1Input') street1Input!: ElementRef;
  @ViewChild('street2Input') street2Input!: ElementRef;
  @ViewChild('cityInput') cityInput!: ElementRef;
  @ViewChild('stateInput') stateInput!: ElementRef;
  @ViewChild('postalCodeInput') postalCodeInput!: ElementRef;
  manufacturers!: string;
  manufacturerInfo!: ManufacturerInfoModel;
  states: StatesDisplayAndAPI[] = stateDisplayNameAndApiName;
  formType !: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.manufacturers = this.currentForm.get('manufacturers')?.value;
    this.manufacturerInfo = new ManufacturerInfoModel(this.currentForm.get('manufacturerInfo')?.value);
    this.formType = this.currentForm.get('formType')?.value;
  }

  public clearManufacturersInputField() {
    this.errorCheck('manufacturers');
    this.manufacturers = '';
    this.currentForm.patchValue({'manufacturers': ''});
  }

  public updateManufacturers(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.manufacturers = '';
      }
    }
    
    this.errorCheck('manufacturers');
    this.currentForm.patchValue({'manufacturers': this.manufacturers});
  }

  public cancelManufacturersUpdate() {
    this.manufacturers = this.currentForm.get('manufacturers')?.value;
  }

  public clearNameInputField() {
    this.manufacturerInfo.name = '';
    this.formManufacturerInfo?.patchValue({'name': ''});
  }
  public updateName(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.manufacturerInfo.name = '';
      }
    }
    this.formManufacturerInfo?.patchValue({'name': this.manufacturerInfo.name});
  }

  public cancelNameUpdate() {
    this.manufacturerInfo.name = this.formManufacturerInfo?.get('name')?.value;
  }

 public clearStreet1InputField() {
    this.manufacturerInfo.street1 = '';
    this.formManufacturerInfo?.patchValue({'street1': ''});
  }

  public updateStreet1(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.manufacturerInfo.street1 = '';
      }
    }
    this.formManufacturerInfo?.patchValue({'street1': this.manufacturerInfo.street1});
  }

  public cancelStreet1Update() {
    this.manufacturerInfo.street1 = this.formManufacturerInfo?.get('street1')?.value;
  }
  
  
 public clearStreet2InputField() {
    this.manufacturerInfo.street2 = '';
    this.formManufacturerInfo?.patchValue({'street2': ''});
  }

  public updateStreet2(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.manufacturerInfo.street2 = '';
      }
    }
    this.formManufacturerInfo?.patchValue({'street2': this.manufacturerInfo.street2});
  }

  public cancelStreet2Update() {
    this.manufacturerInfo.street2 = this.formManufacturerInfo?.get('street2')?.value;
  }
  
  public clearCityInputField() {
    this.manufacturerInfo.city = '';
    this.formManufacturerInfo?.patchValue({'city': ''});
  }
  
  public updateCity(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.manufacturerInfo.city = '';
      }
    }
    this.formManufacturerInfo?.patchValue({'city': this.manufacturerInfo.city});
  }

  public cancelCityUpdate() {
    this.manufacturerInfo.city = this.formManufacturerInfo?.get('city')?.value;
  }
  
  public clearStateInputField() {
    this.manufacturerInfo.state = '';
    this.formManufacturerInfo?.patchValue({'state': ''});
  }

  public updateState(event: Event) {
    this.formManufacturerInfo?.patchValue({'state': this.manufacturerInfo.state});
  }

  public cancelStateUpdate() {
    this.manufacturerInfo.state = this.formManufacturerInfo?.get('state')?.value;
  }
  
  public clearPostalCodeInputField() {
    this.manufacturerInfo.postalCode = '';
    this.formManufacturerInfo?.patchValue({'postalCode': ''});
  }
  public updatePostalCode(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.manufacturerInfo.postalCode = '';
      }
    }
    this.formManufacturerInfo?.patchValue({'postalCode': this.manufacturerInfo.postalCode});
  }

  public cancelPostalCodeUpdate() {
    this.manufacturerInfo.postalCode = this.formManufacturerInfo?.get('postalCode')?.value;
  }

  get formManufacturerInfo() {
    return this.currentForm.get('manufacturerInfo');
  }
  
  private errorCheck(fieldName) {
    const targetControl = this.currentForm.get(fieldName);
    
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
